export const NO_USER_ACTIVITY = 'No Other Activity'
